module.exports = __webpack_public_path__ + "img/free.240cabb8.png";